import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';

import ProfileResource from '../api/Profile';
import StudentsResource from '../api/Students';
import RoleResource from '../api/Role';
import TokenResource from '../api/Token';
import LogoutOtherDevices from '../api/LogoutOtherDevices';

import LogResource from '../api/Log';
import RulesResource from '../api/Rules';

import testTaker from '../store/modules/test-taker';

import i18n from '../../locale/i18n.js';

// Todo move the default url configure to external js file
let url = window.location.protocol+"//"+window.location.host;
if(!window.location.port) {}
else if(window.location.protocol==="http:" && window.location.port==80) {}
else if(window.location.protocol==="https:" && window.location.port==443) {}
else {
	url = `${url}:${+window.location.port}`;
}

import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexSession = new VuexPersistence({
	key: 'cwp',
	storage: window.localStorage,
	reducer: state => ({
		accessToken:					state.accessToken,
		credType:						state.credType,
		authUser:						state.authUser,
		browserId:						state.browserId,
		clientID:						state.clientID,
		guid:							state.guid,
		pageTitle:						state.pageTitle,
		profileName:					state.profileName,
		username:							state.username,
		role:									state.role,
		rules:								state.rules,
		adminRole:						state.adminRole,
		profile:			{
			STATUS_FLG:					state.profile.STATUS_FLG,
			ACTIVE_DATE:				state.profile.ACTIVE_DATE,
			USER_FIRST_NAME:		state.profile.USER_FIRST_NAME,
			EXPIRATION_DATE:		state.profile.EXPIRATION_DATE,
			EMAIL_ADDRESS:			state.profile.EMAIL_ADDRESS,
			USER_ID:						state.profile.USER_ID,
			GENDER:							state.profile.GENDER,
			BIRTH_DATE:					state.profile.BIRTH_DATE,
			USER_LAST_NAME:			state.profile.USER_LAST_NAME,
			USER_GUID:					state.profile.USER_GUID,
			FORCE_PASSWORD_CHANGE_FLG: state.profile.FORCE_PASSWORD_CHANGE_FLG,
			LOCALE: state.profile.LOCALE
		},
		selectedAdminLocale:	state.selectedAdminLocale,
		showError:						state.showError,
		students:							state.students,
		selectedStudentRID:		state.selectedStudentRID,
		sidePanelKey:					state.sidePanelKey,
		title:								state.title,
		titleIcon:						state.titleIcon,
		toRoute:							state.toRoute,
		useHeader:						state.useHeader
	})
});

export default new Vuex.Store({
	plugins:		[
		vuexSession.plugin
	],
	modules:		{ testTaker },
	state:			{
		accessToken:					'',
		credType: 						'',
		sessionItems:{
			servername:"",
			sessionId:"",
			started:"",
			first_started:""
		},
		authUser: {
			id:									0,
			firstName:					'',
			lastName:						'',
			schools:						[]
		},
		browserId:						'',
		clientID:							'0d4c4e73-b1d0-41ef-81e9-de05cc6a20b2',
		pageTitle:						'',
		profileName:					'',
		username:							'',
		profile: {
			STATUS_FLG:					'',
			ACTIVE_DATE:				'',
			USER_FIRST_NAME:		'',
			EXPIRATION_DATE:		'',
			EMAIL_ADDRESS:			'',
			USER_ID:						'',
			GENDER:							'',
			BIRTH_DATE:					'',
			USER_LAST_NAME:			'',
			USER_GUID:					'',
			FORCE_PASSWORD_CHANGE_FLG:	'N',
			LOCALE: {}
		},
		selectedAdminLocale:	{
			LOCALE_CODE: 'en-us',
			LOCALE_DISPLAY_TEXT: "English (US)",
			LOCALE_ID: 1
		},
		showWebstoreModal:		false,	
		showError:						false,
		students:							[],
		selectedStudentRID:		'',
		sidePanelKey:					0,
		title:								'',
		titleIcon:						'',
		toRoute:							{},
		useHeader:						true,
		role:									'',
		rules:								{},
		adminRole:						'',
	},
	actions: {
		reset(context) {
			if( context.state.role !== 'admin' ){
				context.commit('setStudents', []);
			}
			context.commit('setRole', '');
			context.commit('setAdminRole', '');
			context.commit('setSelectedStudentRID', 0);
			context.commit('setProfile', {});
			context.commit('setRules', {});
			context.commit('setAccessToken', '');
			context.commit('setSessionItems', {});
			context.commit('setCredType', '');
			context.commit('showError', false);
		},
		clear(context){
			context.commit('setStudents', []);
			context.commit('setRole', '');
			context.commit('setAdminRole', '');
			context.commit('setSelectedStudentRID', 0);
			context.commit('setProfile', {});
			context.commit('setRules', {});
			context.commit('setAccessToken', '');
			context.commit('setSessionItems', {});
			context.commit('setCredType', '');
		},
		initialize(context, studentRid) {
			let pInit = new Promise((resolve, reject) => {
				let pProfile = context.dispatch('fetchProfile');
				let pRole = context.dispatch('fetchRole').then( response => {
					if(response.data.data === 'admin') {
						if(!context.state.adminRole ){
							context.commit('setAdminRole', 'parent');
						}
						// Check the admin locale for moment and then set to default
						if( !!context.state.selectedAdminLocale.LOCALE_CODE ) {
							context.state.selectedAdminLocale.LOCALE_CODE === 'en-us' || 
							context.state.selectedAdminLocale.LOCALE_CODE === 'sa-us' ? 
								moment.locale( 'en' ) : 
								moment.locale( context.state.selectedAdminLocale.LOCALE_CODE );

							context.state.profile.LOCALE = context.state.selectedAdminLocale;
						}

						// Check for Student Rids and push on to student list if they exist;
						if( !!studentRid ){
							let Student = new StudentsResource({
								query: {
									student_rid: studentRid,
								},
							});
							let p = Student.get();
							p.then( () => {
								let students = Student.getResponseData();

								for( let i=0; i < students.length; i++ ) {
									if(!context.getters.student(students[0].STUDENT_RID)) {
										context.commit('addStudent', students[i]);
									} else {
										context.commit('updateStudent', students[i]);
									}
								}
								context.commit('setSelectedStudentRID', students[0].STUDENT_RID);
								context.dispatch('fetchRules').then(() => {
									resolve();
								});
							});
						} else {
							resolve();
						}
					} else if( response.data.data === 'parent' || response.data.data === 'student' ) {
						context.dispatch('fetchStudents').then( () => {
							if( !!context.state.selectedStudentRID ){
								context.dispatch('logAccess');
							}
							context.dispatch('fetchRules').then(() => {
								resolve();
							});
						});
					} else {
						resolve();
						// Not a reconigzed role. Should Log out. Yell at them. Do something.
					}
				});
			});
			return pInit;
		},
		fetchToken(context) {
			let Token = new TokenResource({
				baseUrl: url + '/CommunityWebPortal/_auth/index.cfm/', 
				query: {
					grant_type: 'silent',
					client_id: context.state.clientID,
					redirect_uri: `https://${url}/CommunityWebPortal/_app/?state=`
				},
			});
			let TokenPromise = Token.get();
			let CodeBlockPromise = new Promise((resolve, reject) => {
				TokenPromise.then( response => {
					if( response.data.ERROR === 'session_expired') {
						reject(response);
						context.dispatch('logout');
					} else if( !!response.data.ERROR ) {
						console.warn(response.data.ERROR);
						reject();
					} else {
						let tResp = Token.getResponse().data;
						context.commit('setAccessToken', tResp.access_token);
						context.commit('setSessionItems', tResp);
						if(tResp.hasOwnProperty('credType') && context.getters.credType === ''){
							context.commit('setCredType', tResp.credType);
						}
						resolve(response);
					}
				});
			});

			return CodeBlockPromise;
		},
		logoutOtherDevices(context) {
			let logout = new LogoutOtherDevices({
				baseUrl: url + '/CommunityWebPortal/_auth/index.cfm/', 
			});
			let CodeBlockPromise = logout.get();

			return CodeBlockPromise;
		},
		fetchRules(context){
			let Rules = new RulesResource({
				routeParams: {
					role: context.state.role === 'admin' ? context.state.adminRole : context.state.role
				},
				query: {
					student_rid: context.state.selectedStudentRID ? context.state.selectedStudentRID : undefined
				}
			});
			let p = Rules.get();
			p.then(() => context.commit('setRules', Rules.getResponseData()));
			return p;
		},
		fetchRole(context) {
			let Role = new RoleResource();
			let p = Role.get();
			p.then(() => context.commit('setRole', Role.getResponseData()));
			return p;
		},
		fetchProfile(context) {
			let Profile = new ProfileResource();
			let p = Profile.get();

			p.then(() => {
				context.commit('setProfile', Profile.getResponseData());

				if( Object.keys(context.state.profile.LOCALE).length > 0 ) {
					!!context.state.profile.LOCALE.LOCALE_CODE ?
						i18n.locale = context.state.profile.LOCALE.LOCALE_CODE :
						i18n.locale = 'en-us';

					!!context.state.profile.LOCALE.LOCALE_CODE && 
					context.state.profile.LOCALE.LOCALE_CODE !== 'sa-us' && 
					context.state.profile.LOCALE.LOCALE_CODE !== 'en-us' ?
						moment.locale( context.state.profile.LOCALE.LOCALE_CODE ) :
						moment.locale( 'en' );
				} else {
					if( !!context.state.selectedAdminLocale.LOCALE_CODE ) {
						context.state.selectedAdminLocale.LOCALE_CODE === 'en-us' || 
						context.state.selectedAdminLocale.LOCALE_CODE === 'sa-us' ? 
							moment.locale( 'en' ) : moment.locale( context.state.selectedAdminLocale.LOCALE_CODE );
					}
				}
			});

			return p;
		},
		fetchStudents(context) {
			let Students = new StudentsResource();
			let p = Students.get();
			p.then(() => {
				context.commit('setStudents', []);
				context.commit('setStudents', Students.getResponseData());
				if(Students.getResponseData().length === 1) {
					context.commit('setSelectedStudentRID', Students.getResponseData()[0].STUDENT_RID);
				}
			});
			return p;
		},
		logAccess(context) {
			let Log = new LogResource({
				routeParams: {
					studentRid: context.state.selectedStudentRID,
				}
			});

			Log.post();

		},
		updateSelectedStudentRID(context, studentRid){
			context.commit('setSelectedStudentRID', studentRid);
			context.dispatch('logAccess');
			context.dispatch('fetchRules');
		},
		logout(context, payload) {
			context.dispatch('reset');
			if( !!payload && !!payload.clean && payload.clean ){
				window.location = `/CommunityWebPortal/_auth/index.cfm/security/logout?status=logout`;
			} else {
				window.location = `/CommunityWebPortal/_auth/index.cfm/security/logout?status=logout&redirect_uri=${encodeURIComponent(window.location.href)}`;
			}
		},
		showError(context) {
			context.commit('setError', true);
		},
		hideError(context) {
			context.commit('setError', false);
		},
		resetSelectedStudentRID(context) {
			context.commit('setSelectedStudentRID', '');
		},
		setForcePasswordChangeFlg(context){
			context.commit('setSelectedStudentRID', context);
		}
	},
	mutations:	{
		setError(state, payload) {
			state.showError = payload;
		},
		setRole(state, payload) {
			state.role = payload;
		},
		setAdminRole(state, payload) {
			state.adminRole = payload;
		},
		setProfile(state, payload) {
			state.profile = payload;
		},
		setAccessToken(state, payload) {
			state.accessToken = payload;
		},
		setSessionItems(state, payload) {
			state.sessionItems = payload;
		},
		setCredType(state, payload){
			state.credType = payload;
		},
		setForcePasswordChangeFlg(state, payload){
			state.profile.FORCE_PASSWORD_CHANGE_FLG = payload;
		},
		setSelectedStudentRID(state, payload) {
			state.selectedStudentRID = payload;

			if(payload === 0) {
				state.sidePanelKey += state.sidePanelKey;
			}
		},
		addStudent( state, payload ) {
			state.students.push(payload);
		},
		setStudents( state, payload ) {
			state.students = payload.sort( function compare( a, b ) {
				let dateA = moment( a.BIRTH_DATE );
				let dateB = moment( b.BIRTH_DATE );
				return dateB - dateA;
			} );
		},
		setRules(state, payload) {
			state.rules = payload;
		},
		setUseHeader(state, payload) {
			state.useHeader = payload;
		},
		setTitle(state, payload) {
			state.title = payload;
		},
		setTitleIcon(state, payload) {
			state.titleIcon = payload;
		},
		updateStudent(state, payload) {
			state.students.find(student => {
				if( +student.STUDENT_RID === +payload.STUDENT_RID ) {
					student = payload;
				}
			});
		},
		setProfileLocale(state, payload) {
			state.profile.LOCALE = payload;
		},
		setAdminLocale(state, payload) {
			state.selectedAdminLocale = payload;
		},
		setShowWebstoreModal(state, payload) {
			state.showWebstoreModal = payload;
		}
	},
	getters:	{
		accessToken: state => state.accessToken,
		credType: state => state.credType,
		userGuid: state => state.profile.USER_GUID,
		appIsReady: state => !!state.accessToken,
		userIsAdmin: (state) => state.role === 'admin',
		locale: (state) => state.profile.LOCALE,
		userID: state => state.profile.USER_ID,
		forcePasswordChangeFlg: state => state.profile.FORCE_PASSWORD_CHANGE_FLG,
		role: state => state.role === 'admin' ? state.adminRole : state.role,
		roleRules: state => state.rules[ state.role === 'admin' ? state.adminRole.toUpperCase() : state.role.toUpperCase()],
		selectedStudent: (state) => state.students.find(s => s.STUDENT_RID === state.selectedStudentRID),
		selectedStudentPhoto: (state) => state.students.find(s => s.STUDENT_RID === state.selectedStudentRID).PHOTO_URL,
		student: (state) => (rid) => state.students.find(s => s.STUDENT_RID === rid),
		students: (state) => state.students,
		useHeader: (state) => state.useHeader,
		title: (state) => state.title,
		titleIcon: (state) => state.titleIcon,
		getSidePanelKey: (state) => state.sidePanelKey,
		profileLocale: (state) => state.profile.LOCALE,
		adminLocale: (state) => state.selectedAdminLocale,
		getSelectedLocale: ( state ) => {
			return state.role === 'admin' ? 
				state.selectedAdminLocale : 
				state.profile.LOCALE;
		},
		getShowWebstoreModal: state => state.showWebstoreModal,
		allStudentSchools: (state) => {
			let schools = [];

			for(let s in state.students) {
				let student = state.students[s];

				for(let e in student.ENROLLMENT) {
					let school = student.ENROLLMENT[e];
					let schoolExists = false;

					for(let i in schools) {
						let schoolObject = schools[i];

						if(schoolObject.SCHOOL_ID === school.SCHOOL_ID) {
							schoolExists = true;
						}
					}

					if(!schoolExists) {
						schools.push(school);
					}
				}
			}

			return schools;
		}
	}
});
